import AlertsListItem from './AlertsListItem';

export default AlertsListItem;
